import { UseQueryResult } from '@tanstack/react-query'
import { Download } from 'lucide-react'

import { downloadCSV, getCSVString } from '@fortem-monorepo/js-utilities'
import {
  Button,
  Spinner,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@fortem-monorepo/react-ui'
import { ICReport } from '@fortem-monorepo/web-sdk'

import { useICStreamContext } from '@/pages/funds/ic-report/ic-report-context.context'

type RawScenarioData = {
  t_data: any[]
  tmo_data: any[]
}

export interface DownloadRawDataButtonsProps<TData extends RawScenarioData> {
  filePrefix: string
  query: (
    params: Omit<ICReport.GetICReportDataParams, 'endpoint'>,
    ...args: any[]
  ) => UseQueryResult<TData, Error>
}

export const DownloadRawDataButtons = <TData extends RawScenarioData>({
  query,
  filePrefix,
}: DownloadRawDataButtonsProps<TData>) => {
  const { params } = useICStreamContext()
  const queryResult = query(params)

  const fileName = `${params.fund_name?.toLowerCase()}_${filePrefix}_${params.ed_dt}`

  return (
    <>
      {queryResult.data?.tmo_data && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="outline"
                className="p-1! h-auto!"
                onClick={() => {
                  downloadCSV(getCSVString(queryResult.data?.tmo_data ?? []), `${fileName}_tmo.csv`)
                }}
              >
                {queryResult.isFetching ? <Spinner /> : <Download />}
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Download raw data for T - 1</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      {queryResult.data?.t_data && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="outline"
                className="p-1! h-auto!"
                onClick={async () => {
                  downloadCSV(getCSVString(queryResult.data?.t_data ?? []), `${fileName}_t.csv`)
                }}
              >
                {queryResult.isFetching ? <Spinner /> : <Download />}
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Download raw data for T</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </>
  )
}
